import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledFilterListButton = styled.span`
  display: block;
  color: ${tvar('colors.button.secondary.fg')};
  letter-spacing: 0.05rem;
  border: 0.14rem solid ${tvar('colors.button.secondary.border')};
  font-size: ${tvar('typographies.base.fontSize')};
  font-weight: normal;
  padding: ${tvar('space.double')} ${tvar('space.quadruple')};
  align-self: flex-end;
  transition:
    0.2s background ease-in-out,
    0.2s border ease-in-out;
  width: auto;

  &:not(:last-child) {
    margin-bottom: ${tvar('space.x2')};
  }

  &:hover {
    border-color: ${tvar('colors.button.secondary.borderHover')};
    background: ${tvar('colors.button.secondary.bgHover')};
  }
`;
